import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import Header from '../blocks/header/header';
import Basket from '../blocks/basket/basket';
import Brands from '../blocks/brands/brands';
import Checkout from '../blocks/checkout/checkout';
import Product from '../blocks/product/product';
import Field from '../blocks/field/field';
import MyLoyalty from '../blocks/my-loyalty/my-loyalty';
import MySubscribes from '../blocks/my-subscribes/my-subscribes';
import Orders from '../blocks/orders/orders';
import Footer from '../blocks/footer/footer';
import Favorites from '../blocks/favorites/favorites';
import Select from '../blocks/select/select';
import RecommendSlider from '../blocks/recommend/recommend';
import Alphabet from '../blocks/alphabet/alphabet';
import ContactsForm from '../blocks/contacts/contacts';
import Tabs from '../blocks/tabs/tabs';
import Item from '../blocks/item/item';
import QuestionForm from '../blocks/question/question';
import Share from '../blocks/share/share';
import Subscribe from '../blocks/subscribe/subscribe';
import SliderMak from '../blocks/slider-mak/slider-mak';
import Aside from '../blocks/aside/aside';
import 'jquery.inputmask/dist/jquery.inputmask.bundle';
import Search from '../blocks/search/search';
import Autocomplete from '../blocks/autocomplete/autocomplete';
import 'jquery.csssr.validation';
import format from 'number-format.js';
import 'malihu-custom-scrollbar-plugin';
import 'jquery-mousewheel';
import ContentHidden from '../blocks/atelier/atelier';
import CorpLifeNews from '../blocks/corporate-life/corporate-life';
import Filter from '../blocks/filter/filter';
import Category from '../blocks/category/category';
import SearchList from '../blocks/search-list/search-list';
import FilterProduct from '../blocks/product-list/product-list';
import FilterMobile from '../blocks/filter/filter-mobile/filter-mobile';
import FilterBrand from '../blocks/brand-card/brand-card';
import Favorite from '../blocks/favorite/favorite';
import Popup from '../blocks/popup/popup';
import SizeChart from '../blocks/size-chart/size-chart';
import SliderItem from '../blocks/slider-item/slider-item';
import Map from '../blocks/map/map';
import Info from '../blocks/info/info';
import News from '../blocks/news-event/news';
import Exchange from '../blocks/exchange-return/exchange-return';
import emailValidation from '../blocks/form/';
import SlideToggle from '../blocks/slide-toggle/slide-toggle';
import Toggle from '../blocks/toggle';
import Upload from '../blocks/upload';
import HistoryList from '../blocks/history';
import Landing from '../blocks/langing';
import JobForm from '../blocks/job';
import Journals from '../blocks/journals/journals';
import MyAdress from '../blocks/pa-my-address/pa-my-adress';
import MyData from '../blocks/pa-my-data/';
import Vacancy from '../blocks/vacancy/';
import LoyaltyCard from '../blocks/my-loyalty/loyalty-card/';
import scrollToTop from '../blocks/scroll-to-top/';
import buttonMobileHover from '../blocks/button/';
import toggleInvestList from '../blocks/invest/';
import mainHeightIE from '../blocks/main/';
import {addClassIE} from '../blocks/main/';
import 'jquery.scrollbar';
import notice from '../blocks/notice/notice';

$(() => {
	new Header().render();
	new Basket().render();
	new Brands().render();
	new Checkout().render();
	new Product().render();
	new Field().render();
	new MyLoyalty().render();
	new MySubscribes().render();
	new Orders().render();
	new Footer().render();
	new SliderMak().render();
	new RecommendSlider().render();
	new Alphabet().render();
	new Aside().render();
	new ContentHidden().render();
	new CorpLifeNews().render();
	new Search().render();
	new Autocomplete().render();
	new Filter().render();
	new Category().render();
	new FilterProduct().render();
	new SearchList().render();
	new Share().render();
	new FilterMobile().render();
	new FilterBrand().render();
	new Favorite().render();
	new Favorites().render();
	new Popup().render();
	new SizeChart().render();
	new SliderItem().render();
	new Subscribe().render();
	new ContactsForm().render();
	new QuestionForm().render();
	new Item().render();
	new Map().render();
	new Info().render();
	new News().render();
	new Exchange().render();
	new SlideToggle().render();
	new Toggle().render();
	new Upload().render();
	new HistoryList().render();
	new Landing().render();
	new JobForm().render();
	new Tabs().render();
	new Journals().render();
	new Select().render();
	new MyAdress().render();
	new MyData().render();
	new Vacancy().render();
	new LoyaltyCard().render();
	notice();
	buttonMobileHover();
	toggleInvestList();
	scrollToTop();
	emailValidation();
	mainHeightIE();
	addClassIE();
	svg4everybody();

	$('.js-scrollbar').mCustomScrollbar({
		theme: 'custom',
		scrollInertia: 0
	});

	$('.js-scrollbar-hor').mCustomScrollbar({
		theme: 'custom',
		axis: 'x',
		scrollInertia: 0
	});

	$('.js-price').each((i, elem) => {
		const $price = parseInt($(elem).text(), 10);
		if (!isNaN($price)) {
			$(elem).text(format( '# ##0.##\u00A0₽', $price));
		}
	});

	$('.js-textarea').scrollbar();
});



/** WEBPACK FOOTER **
 ** ./app/scripts/app.js
 **/